import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldCheck, Waves, Trees, Baby } from 'lucide-react';

const AboutSection = () => {
  const { t } = useTranslation();
  
  const features = [
    {
      icon: <ShieldCheck className="w-8 h-8" />,
      title: t('about.features.security.title'),
      description: t('about.features.security.description')
    },
    {
      icon: <Waves className="w-8 h-8" />,
      title: t('about.features.pool.title'),
      description: t('about.features.pool.description')
    },
    {
      icon: <Trees className="w-8 h-8" />,
      title: t('about.features.park.title'),
      description: t('about.features.park.description')
    },
    {
      icon: <Baby className="w-8 h-8" />,
      title: t('about.features.playground.title'),
      description: t('about.features.playground.description')
    }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left: Text Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#003366] mb-6">
              {t('about.title')}
            </h2>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              {t('about.description')}
            </p>

            {/* Feature Icons */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-10">
              {features.map((feature, index) => (
                <div key={index} className="text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 text-[#0052CC] rounded-full mb-3">
                    {feature.icon}
                  </div>
                  <h3 className="font-semibold text-sm text-gray-900 mb-1">{feature.title}</h3>
                  <p className="text-xs text-gray-600">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <img
              src="https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/m4pbe412_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-28%20%D0%B2%2010.21.55.png"
              alt="Residencial Los Jardines"
              className="rounded-lg shadow-2xl w-full h-[500px] object-cover"
            />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-lg shadow-xl">
              <p className="text-3xl font-bold text-[#FFC400]">15+</p>
              <p className="text-sm text-gray-600">{t('about.apartmentsCount')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;